module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fc-Ge-Hc-Ia.fa3e4b1f.png";